export default __webpack_public_path__ + "static/Lense_3.6mm_Angle_of_View-79332075c918e1a559566ab5bdd38c69.webp";